import React, { useState, useEffect } from 'react';
import { Avatar, Form, Input, Button } from 'antd';
import { EmailFormCard } from './styled';
import { useStore } from '../../../../../../../hooks/storeContext';

const EmailCardComponent = ({ item, theme, storeName }) => {
    const { authStore } = useStore();
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (submitted && formData) {
            handleEmailSubmit(formData);
        }
    }, [submitted, formData]);

    const onFinish = (values) => {
        setFormData(values);
        setSubmitted(true);
    };

    const handleEmailSubmit = async (values) => {
        try {
            await authStore.addEmailUser({
                name: values.name,  
                email: values.email,
                source: item.text,  
                storeName: storeName,
                product: item.text,
            });
        } catch (error) {
            console.error("Error submitting email:", error);
            setSubmitted(false);
            setError("An error occurred. Please try again.");
        }
    };

    const hasImage = !!item.thumbnail;

    return (
        <EmailFormCard theme={theme}>
            {submitted ? (
                <div style={{ textAlign: 'center', color: theme?.card_text_color, padding: '20px' }}>
                    <h3>Thank you for your Submission!</h3>
                </div>
            ) : (
                <>
                    <div className="product-content">
                        {hasImage && (
                            <div className="product-image">
                                <Avatar shape="square" size={80} src={item.thumbnail} />
                            </div>
                        )}
                        <div className="product-info" style={{ textAlign: hasImage ? 'left' : 'center' }}>
                            <h3>{item.text}</h3>
                            <p>{item.subtitle}</p>
                        </div>
                    </div>
                    <Form layout="vertical" onFinish={onFinish}>
                        <Form.Item name="name" rules={[{ required: true, message: 'Please enter your name' }]}>
                            <Input style={{border:'2px solid #d9d9d9'}} placeholder="Enter your name" />
                        </Form.Item>
                        <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}>
                            <Input style={{border:'2px solid #d9d9d9'}} placeholder="Enter your email" />
                        </Form.Item>
                        <Button type="primary" className='product-button' htmlType="submit">
                            {item.buttonName || 'Submit & Download'}
                        </Button>
                    </Form>
                    {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                </>
            )}
        </EmailFormCard>
    );
};

export default EmailCardComponent;